import { useContext } from "react";
import { MenuContext } from "../../context/Menu";

export const useMenuContext = () => {
    const context = useContext(MenuContext);
    if (!context) {
        throw Error("useMenuContext without provider");
    }
    return context;
}